//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            telePhone: this.$route.query.telePhone || '',
            openid: this.$route.query.openid || '',
            filefdfspath: 'https://service.51bjhzy.com/',
            doctorid: '',
            headphoto: '',
            doctorname: '',
            duties: '',
            hospitaname: '',
            hospitanameList: [],
            department: '',
            auditmoney: '',
            accountbalance: '',
            money: '',
            isDeposit: false
        }
    },
    //挂载完成
    methods: {
        //去提现
        goCash(){
            if(this.accountbalance > 0){
                this.$router.push({path: '/cash',query:{doctorid: this.doctorid,openid: this.openid,telePhone: this.telePhone}});
            }
        },
        //缴税详情
        goRule(){
            this.$router.push({path: '/Rule',query:{doctorid: this.doctorid}});
        },
        getDoctor(){
             let params = {
                telePhone: this.telePhone,
                openid: this.openid,
            }
            this.$doRequest("api/AppHomePage/gainDoctor", params,res => {
                this.doctorid = res.doctorid;
                this.headphoto = res.headphoto;
                this.doctorname = res.doctorname;
                this.duties = res.duties;
                this.hospitaname = res.hospitaname;

                //特殊医生出来（多个认证医院）
                if(this.hospitaname.indexOf('，') != -1){
                    this.hospitanameList = this.hospitaname.split('，');
                }

                this.department = res.department;
                if(res.auditmoney == 0 || !res.auditmoney || res.auditmoney == null){
                    this.auditmoney = '0.00';
                }else{
                    this.auditmoney = res.auditmoney;
                }
                if(res.accountbalance == 0 || !res.accountbalance || res.accountbalance == null){
                    this.accountbalance = '0.00';
                }else{
                    this.accountbalance = res.accountbalance;
                    this.isDeposit = true;
                }
                if(res.money == 0){
                    this.money = '0.00';
                }else{
                    this.money = res.money;
                }
            });
        }
    },
    //生命周期之创建完成
    created: function() {
        this.getDoctor();
        document.title = '提现';
    }
}



// WEBPACK FOOTER //
// ./src/views/doctorDetails/index.vue